import React from 'react'
import {  ArrowUpRight, Clipboard, ClipboardCheck, FileCheck, FileSpreadsheet, FileText, ShieldCheck, User, UserCheck } from "lucide-react";
import { Link } from 'react-router-dom';

function FillingReturns() {
    const services = [
        { icon: <Clipboard className="w-6 h-6 text-blue-600" />, title: "HST Returns Filing", desc: "Timely and accurate filing of periodic HST returns to ensure compliance." },
        { icon: <ShieldCheck className="w-6 h-6 text-blue-600" />, title: "WSIB Returns Filing", desc: "Ensuring proper submission of WSIB returns for workplace safety compliance." },
        { icon: <UserCheck className="w-6 h-6 text-blue-600" />, title: "Payroll Returns Filing", desc: "Accurate payroll tax filings to meet employer obligations." },
        { icon: <FileSpreadsheet className="w-6 h-6 text-blue-600" />, title: "EHT Returns Filing", desc: "Managing Employer Health Tax (EHT) filings with accuracy." },
        { icon: <FileText className="w-6 h-6 text-blue-600" />, title: "T4/T4A/T5 Slips Filing", desc: "Preparing and filing employee and shareholder tax slips annually." },
        { icon: <ClipboardCheck className="w-6 h-6 text-blue-600" />, title: "Record of Employment (ROE)", desc: "Filing ROE forms when required for employees." },
        { icon: <FileCheck className="w-6 h-6 text-blue-600" />, title: "Corporate Tax Returns (T2)", desc: "Annual corporate tax return preparation and submission." },
        { icon: <User className="w-6 h-6 text-blue-600" />, title: "Personal Tax Returns (T1)", desc: "Filing personal income tax returns efficiently and accurately." }
      ];
      
    
      return (
        <div className="w-full">
          {/* Hero Section */}
          <section
            className="relative text-center w-full h-[600px] lg:h-[700px] flex items-center justify-center"
            style={{
              backgroundImage: "url('images/taxreturn.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-white px-6">
              <h1 className="text-4xl md:text-6xl lg:text-8xl font-bold mb-4">Filing Government Tax Returns</h1>
              <p className="text-lg md:text-2xl lg:text-3xl max-w-4xl text-gray-400">
              Filing government returns made easy! We simplify taxes for franchises and help you maximize profits—your trusted accounting partner!
              </p>
            </div>
          </section>
    
          {/* Main Content Section */}
          <div className="bg-slate-900 py-12 px-6 md:px-16">
            <div className="flex flex-wrap items-center justify-center gap-12 max-w-7xl mx-auto">
              {/* Text Content */}
              <div className="text-center max-w-3xl lg:max-w-4xl">
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-100">
                  Franchise Accounting & Advisory
                </h2>
                <p className="text-lg md:text-xl text-gray-400 mt-6 text-justify">
                Ensure hassle-free government returns with our expert accounting services. We simplify tax filing for franchises, ensuring compliance while maximizing profitability. Let us handle the complexities so you can focus on growing your business with confidence!
                </p>
                <p className="text-lg md:text-xl text-gray-400 mt-4 text-justify">
                Simplify government tax filing with our expert accounting services. We ensure accurate, timely submissions while maximizing deductions and maintaining full compliance. From tax preparation to strategic planning, we help your business navigate complex tax regulations with ease. Let us handle the details so you can focus on growth with confidence!
                </p>
                <div className="flex mt-6 justify-center">
                           <Link to="/contactus">
                  <button className="flex items-center gap-2 bg-amber-300 text-black p-3 px-6 text-lg font-semibold hover:bg-amber-600 transition">
                    Schedule A Call
                    <ArrowUpRight size={20} />
                  </button></Link>
                </div>
              </div>
    
              {/* Service Cards Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10 max-w-6xl mx-auto">
                {services.map((service, index) => (
                  <div key={index} className="bg-white p-6 shadow-md rounded-lg hover:shadow-lg transition-all">
                    <div className="flex items-center space-x-3">
                      {service.icon}
                      <h3 className="text-xl font-semibold text-gray-800">{service.title}</h3>
                    </div>
                    <p className="text-gray-600 mt-2">{service.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      );
    }
    

export default FillingReturns